import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home'
import index from '@/view/index'
import about from '@/view/about'
import product from '@/view/product'
import caseSuccess from '@/view/case'
import education from '@/view/product/education'
import knowledgePay from '@/view/product/knowledgePay'
import socialSystem from '@/view/product/socialSystem'
import marketingSystem from '@/view/product/marketingSystem'
import sinatv from '@/view/product/sinatv'
import interactionLive from '@/view/product/interactionLive'
import shortVideo from '@/view/product/shortVideo'
import socialContact from '@/view/product/socialContact'
import memberContact from '@/view/product/memberContact'
import ongoing from '@/view/product/ongoing'
import marketing from '@/view/product/marketing'
import warehouse from '@/view/product/warehouse'
import cityoto from '@/view/product/cityoto'
import community from '@/view/product/community'
import groupBuying from '@/view/product/groupBuying'
import brushFace from '@/view/product/brushFace'
import newList from '@/view/new/newList'
import newProduct from '@/view/new/newProduct'
Vue.use(Router)

const router = new Router({
  // mode: 'history',

  // scrollBehavior(to, from, savedPosition) {
  //   let name = to.name;
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     if (name == 'index') {
  //       localStorage.setItem("jykNavIndex", 0);
  //     } else if (name == 'mobileAd') {
  //       localStorage.setItem("jykNavIndex", 2);
  //     } else if (name == 'casepage') {
  //       localStorage.setItem("jykNavIndex", 3);
  //     } else if (name == 'about') {
  //       localStorage.setItem("jykNavIndex", 4);
  //     } else {
  //       localStorage.setItem("jykNavIndex", 1);
  //     }
  //     return { x: 0, y: 0 }
  //   }
  // },
  routes: [
    // 首页
    {
      path: '/',
      component: home,
      redirect: index,
      children: [
        {
          path: '/index',
          name: 'index',
          component: index,
        },
        {
          path: '/product',
          name: 'product',
          component: product,
        },
        {
          path: '/case',
          name: 'case',
          component: caseSuccess,
        },
        {
          path: '/about',
          name: 'about',
          component: about,
        },
        {
          path: '/product/education',
          name: 'education',
          component: education,
        },
        {
          path: '/product/knowledgePay',
          name: 'knowledgePay',
          component: knowledgePay,
        },
        {
          path: '/product/socialSystem',
          name: 'socialSystem',
          component: socialSystem,
        },
        {
          path: '/product/marketingSystem',
          name: 'marketingSystem',
          component: marketingSystem,
        },
        {
          path: '/product/sinatv',
          name: 'sinatv',
          component: sinatv,
        },
        {
          path: '/product/interactionLive',
          name: 'interactionLive',
          component: interactionLive,
        },
        {
          path: '/product/shortVideo',
          name: 'shortVideo',
          component: shortVideo,
        },
        {
          path: '/product/socialContact',
          name: 'socialContact',
          component: socialContact,
        },
        {
          path: '/product/memberContact',
          name: 'memberContact',
          component: memberContact,
        },
        {
          path: '/product/ongoing',
          name: 'ongoing',
          component: ongoing,
        },
        {
          path: '/product/marketing',
          name: 'marketing',
          component: marketing,
        },
        {
          path: '/product/warehouse',
          name: 'warehouse',
          component: warehouse,
        },
        {
          path: '/product/cityoto',
          name: 'cityoto',
          component: cityoto,
        },
        {
          path: '/product/community',
          name: 'community',
          component: community,
        },
        {
          path: '/product/groupBuying',
          name: 'groupBuying',
          component: groupBuying,
        },
        {
          path: '/product/brushFace',
          name: 'brushFace',
          component: brushFace,
        },
        {
          path: '/newProduct',
          name: 'newProduct',
          component: newProduct,
      },
      {
          path: '/newList',
          name: 'newList',
          component: newList,
      },
         
      ]
    },

  ]
})
/**
   * @param {to} 将要去的路由
   * @param {from} 出发的路由
   * @param {next} 执行下一步
   */
router.beforeEach((to, from, next) => {
  next()
  // if (to.meta.needLogin && !$store.state.isLogin) {
  //   next({
  //     path: '/login'
  //   })
  // } else {
  //   next()
  // }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js